// extracted by mini-css-extract-plugin
export var Hero = "placements-module--Hero--0f5d7";